import React from 'react';
import style from './HowItWorks.module.scss';
import openTheAppImg from '../imgs/howitworks-1-open.png';
import chooseAPinImg from '../imgs/howitworks-2-choose.png';
import pressPlayImg from '../imgs/howitworks-3-play.png';

const STEPS = [
    {
        title: 'Open the app',
        body: 'Open the app anywhere — A street, a building, any location. ‘Where’ the story took place Brings the ‘history’.',
        image: openTheAppImg,
    },
    {
        title: "Choose a location and see what's pinned there",
        body: 'A map of nearby short films appears, each one tied to the exact spot Where the story took place.',
        image: chooseAPinImg,
    },
    {
        title: 'Press play',
        body: 'A short film — often told by the people who lived it — brings the history to life in front of you.',
        image: pressPlayImg,
    },
];

const HowItWorks = () => (
    <section id="how-it-works" className={style.howItWorks}>
        <div className="wrap">
            <div className={`section-head ${style.sectionHead}`}>
                <div className="eyebrow">How it works</div>
                <h2>Three steps, and the past is playing.</h2>
                <p>No archive to dig through, no plaque to squint at, no closed museum. Just a phone, a place, and the history of waiting where it happened.</p>
            </div>
            <div className={style.steps}>
                {STEPS.map((step) => (
                    <div className={style.step} key={step.title}>
                        <div className={style.stepImage}><img src={step.image} alt={step.title} /></div>
                        <h3>{step.title}</h3>
                        <p>{step.body}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default HowItWorks;
